import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
// import Completion from "../misc/Completion";

// Card data
const projects = [
    {
        title: "AI-Powered Portfolio",
        description:
            "A smart portfolio with smooth, responsive animations and a built-in AI chatbot that talks about the owner.",
        image: `${process.env.PUBLIC_URL}/media/thumbnails/portfolio.jpg`,
        githubLink: "https://github.com/prathamreet",
        websiteLink: "https://prathamreet.netlify.app",
        technologies: ["MERN Stack"],
    },

    {
        title: "TimeTable Schedule",
        description: "A customizable React app for managing schedules, configurable via a JSON file. Made in 2hrs",
        image: `${process.env.PUBLIC_URL}/media/thumbnails/timetable.jpg`, // Placeholder image URL
        githubLink: "https://github.com/prathamreet/timetable",
        websiteLink: "https://eztt.netlify.app",
        technologies: ["react"],
    },
    
    {
        title: "INSTAFICATION",
        description:
            "Instagram follow-back checker. Find out who is not following you back!",
        image: `${process.env.PUBLIC_URL}/media/thumbnails/Instafication.jpg`, // Placeholder image URL
        githubLink: "https://github.com/prathamreet/instafication",
        websiteLink: "https://prathamreet.github.io/instafication/",
        technologies: ["HTML", "CSS", "JavaScript"],
    },
    {
        title: "Thanks",
        description: "Discord Reminder Bot",
        image: `${process.env.PUBLIC_URL}/media/thumbnails/DiscordRemainderBot.jpg`, // Placeholder image URL
        githubLink: "https://github.com/prathamreet/thanks",
        websiteLink:
            "https://discord.com/oauth2/authorize?client_id=1270065195519316009&permissions=1133584&scope=bot",
        technologies: ["javascript", "node.js", "discord.js"],
    },
];

const Project = () => {
    useEffect(() => {
        AOS.init({ duration: 1000, once: false }); // Initialize AOS with desired options
    }, []);

    return (
        <>
            <div className="ubuntu-regular my-10">
                {/* <Completion
                    percentage="98"
                    status="Showing open-source projects, as private projects are sold and do not carry Creative Commons licenses."
                /> */}

                <div className="container mx-auto rounded-lg">
                    <h2 className="text-4xl font-bold text-left my-8">
                        Projects
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-20">
                        {projects.map((project, index) => (
                            <div
                                key={index}
                                className="card w-full rounded-lg overflow-hidden h-full flex flex-col shadow"
                                data-aos="fade-up" // Apply AOS animation
                            >
                                <div className="transition-transform duration-300 hover:scale-105">
                                    <figure
                                        className="w-full h-48 md:h-64 bg-gray-100 overflow-hidden"
                                        data-aos="fade-in"
                                    >
                                        <img
                                            src={project.image}
                                            alt={project.title}
                                            className="object-cover w-full h-full"
                                        />
                                    </figure>
                                    <div
                                        className="card-body p-4 sm:p-6 flex flex-col flex-grow"
                                        data-aos="fade-up"
                                    >
                                        <h2 className="card-title text-lg sm:text-xl lg:text-xl flex justify-between items-center my-2">
                                            {project.title}
                                            <div className="flex space-x-2">
                                                <a
                                                    href={project.githubLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-gray-500 hover:text-gray-900 mx-2"
                                                    data-aos="zoom-in"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24"
                                                        width="24"
                                                        height="24"
                                                        fill="currentColor"
                                                    >
                                                        <path d="M5.88401 18.6533C5.58404 18.4526 5.32587 18.1975 5.0239 17.8369C4.91473 17.7065 4.47283 17.1524 4.55811 17.2583C4.09533 16.6833 3.80296 16.417 3.50156 16.3089C2.9817 16.1225 2.7114 15.5499 2.89784 15.0301C3.08428 14.5102 3.65685 14.2399 4.17672 14.4263C4.92936 14.6963 5.43847 15.1611 6.12425 16.0143C6.03025 15.8974 6.46364 16.441 6.55731 16.5529C6.74784 16.7804 6.88732 16.9182 6.99629 16.9911C7.20118 17.1283 7.58451 17.1874 8.14709 17.1311C8.17065 16.7489 8.24136 16.3783 8.34919 16.0358C5.38097 15.3104 3.70116 13.3952 3.70116 9.63971C3.70116 8.40085 4.0704 7.28393 4.75917 6.3478C4.5415 5.45392 4.57433 4.37284 5.06092 3.15636C5.1725 2.87739 5.40361 2.66338 5.69031 2.57352C5.77242 2.54973 5.81791 2.53915 5.89878 2.52673C6.70167 2.40343 7.83573 2.69705 9.31449 3.62336C10.181 3.41879 11.0885 3.315 12.0012 3.315C12.9129 3.315 13.8196 3.4186 14.6854 3.62277C16.1619 2.69 17.2986 2.39649 18.1072 2.52651C18.1919 2.54013 18.2645 2.55783 18.3249 2.57766C18.6059 2.66991 18.8316 2.88179 18.9414 3.15636C19.4279 4.37256 19.4608 5.45344 19.2433 6.3472C19.9342 7.28337 20.3012 8.39208 20.3012 9.63971C20.3012 13.3968 18.627 15.3048 15.6588 16.032C15.7837 16.447 15.8496 16.9105 15.8496 17.4121C15.8496 18.0765 15.8471 18.711 15.8424 19.4225C15.8412 19.6127 15.8397 19.8159 15.8375 20.1281C16.2129 20.2109 16.5229 20.5077 16.6031 20.9089C16.7114 21.4504 16.3602 21.9773 15.8186 22.0856C14.6794 22.3134 13.8353 21.5538 13.8353 20.5611C13.8353 20.4708 13.836 20.3417 13.8375 20.1145C13.8398 19.8015 13.8412 19.599 13.8425 19.4094C13.8471 18.7019 13.8496 18.0716 13.8496 17.4121C13.8496 16.7148 13.6664 16.2602 13.4237 16.051C12.7627 15.4812 13.0977 14.3973 13.965 14.2999C16.9314 13.9666 18.3012 12.8177 18.3012 9.63971C18.3012 8.68508 17.9893 7.89571 17.3881 7.23559C17.1301 6.95233 17.0567 6.54659 17.199 6.19087C17.3647 5.77663 17.4354 5.23384 17.2941 4.57702L17.2847 4.57968C16.7928 4.71886 16.1744 5.0198 15.4261 5.5285C15.182 5.69438 14.8772 5.74401 14.5932 5.66413C13.7729 5.43343 12.8913 5.315 12.0012 5.315C11.111 5.315 10.2294 5.43343 9.40916 5.66413C9.12662 5.74359 8.82344 5.69492 8.57997 5.53101C7.8274 5.02439 7.2056 4.72379 6.71079 4.58376C6.56735 5.23696 6.63814 5.77782 6.80336 6.19087C6.94565 6.54659 6.87219 6.95233 6.61423 7.23559C6.01715 7.8912 5.70116 8.69376 5.70116 9.63971C5.70116 12.8116 7.07225 13.9683 10.023 14.2999C10.8883 14.3971 11.2246 15.4769 10.5675 16.0482C10.3751 16.2156 10.1384 16.7802 10.1384 17.4121V20.5611C10.1384 21.5474 9.30356 22.2869 8.17878 22.09C7.63476 21.9948 7.27093 21.4766 7.36613 20.9326C7.43827 20.5204 7.75331 20.2116 8.13841 20.1276V19.1381C7.22829 19.1994 6.47656 19.0498 5.88401 18.6533Z"></path>
                                                    </svg>
                                                </a>
                                                <a
                                                    href={project.websiteLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-gray-500 hover:text-gray-900 mx-2"
                                                    data-aos="zoom-in"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24"
                                                        width="24"
                                                        height="24"
                                                        fill="currentColor"
                                                    >
                                                        <path d="M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V12L17.206 8.207L11.2071 14.2071L9.79289 12.7929L15.792 6.793L12 3H21Z"></path>
                                                    </svg>
                                                </a>
                                            </div>
                                        </h2>
                                        <p
                                            className="text-sm sm:text-base lg:text-lg text-gray-600 flex-grow"
                                            data-aos="fade-right"
                                        >
                                            {project.description}
                                        </p>
                                        <div
                                            className="card-actions flex-wrap gap-2 mt-2"
                                            data-aos="fade-left"
                                        >
                                            {project.technologies.map(
                                                (tech, i) => (
                                                    <span
                                                        key={i}
                                                        className="badge badge-outline"
                                                    >
                                                        {tech}
                                                    </span>
                                                )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div
                    className="container mx-auto rounded-lg shadow mt-10 p-4 text-center kanit-light animate-pulse"
                    data-aos="zoom-in-up"
                >
                    Out of 26 projects, the following are small open-source
                    repositories. The remaining projects are private or sold and
                    cannot be displayed due to copyright restrictions.
                </div>
            </div>
        </>
    );
};

export default Project;
